/**
 * schedulingLinks
 *
 * Centralized URLs for booking/scheduling across the app.
 */

// HubSpot meetings link for Kevin (replaces legacy Calendly links that invoice Kevin)
export const kevinMeetingUrl = 'https://meetings.hubspot.com/dan2005/advocacy-labs-sales';

// RoboCent quick consult link (kept for RoboCent-specific flows)
export const robocentQuickfireUrl = 'https://meetings.hubspot.com/hector200/sales-team-quickfire?uuid=773f2aea-d7c6-4cd6-9969-606b9a3ad776';

export default {
  kevinMeetingUrl,
  robocentQuickfireUrl
};


